import React, { useState } from "react"
import { css } from "styled-components"

import { ProgressBar } from "../atoms/progress-bar"
import { Text, T } from "../atoms/text"
import mergeVariants, { TVariantProp } from "../util/merge-variants"
import VariantContainer from "../atoms/variant-container"

export type TVideoDetails = {
  title: string
  start: number
  end: number
}

type TVideoProgress = {
  playedSeconds: number
  played: number
  loadedSeconds: number
  loaded: number
}

export interface IVideoProgressBar {
  details: TVideoDetails
  videoProgress: TVideoProgress
  seekMethod: (timestamp: number) => void
  titleVariants?: TVariantProp
}

const VideoProgressBar = ({
  details,
  videoProgress,
  seekMethod,
  titleVariants,
}: IVideoProgressBar) => {
  const adjustedPosition = videoProgress.playedSeconds - details.start
  const adjustedEnd = details.end - details.start - 0.001

  let progress = (adjustedPosition / adjustedEnd) * 100
  progress = 0 <= progress && progress <= 120 ? progress : 0

  const isActive = progress > 0 && progress <= 100

  const [wasJustClicked, setWasJustClicked] = useState(false)

  const clickHandler = () => {
    setWasJustClicked(true)
    seekMethod(details.start)
    setTimeout(() => {
      setWasJustClicked(false)
    }, 100)
  }

  return (
    <VariantContainer
      onClick={clickHandler}
      // component wrapper
      variants={[
        css`
          display: grid;
          grid-gap: 12px;
          grid-template-columns: 1fr;

          cursor: pointer;
          user-select: none;
          align-self: end;
        `,
      ]}
    >
      <Text
        variants={mergeVariants(
          [
            css`
              color: var(--white);
              ${T.lg.h6`500`};
            `,
          ],
          titleVariants
        )}
      >
        {details.title}
      </Text>
      <VariantContainer
        // progress bar grey background color
        variants={[
          css`
            width: 100%;
            height: 2px;
            background-color: lightgrey;
            overflow: hidden;
          `,
        ]}
      >
        <ProgressBar
          isActive={isActive}
          progressPercent={progress}
          disableAnimation={wasJustClicked}
        />
      </VariantContainer>
    </VariantContainer>
  )
}

export default VideoProgressBar
